export const PROJECT_NAME = window.location.host.split('.')[0];
export const REACT_APP_BASE_URL = `https://${window.location.host.split('.')[0]}.api.insent.ai/`;
export const REACT_APP_BASE_URL_FE = `https://${
  window.location.host.split('.')[0]
}.widget.insent.ai/`;
export const REACT_APP_SENTRY_DSN = window.env
  ? window.env.REACT_APP_SENTRY_DSN
  : process.env.REACT_APP_SENTRY_DSN;
export const REACT_APP_STRIPE_KEY = window.env
  ? window.env.REACT_APP_STRIPE_KEY
  : process.env.REACT_APP_STRIPE_KEY;
export const REACT_APP_REDIRECT_URI_SALESFORCE = window.env
  ? window.env.REACT_APP_REDIRECT_URI_SALESFORCE
  : process.env.REACT_APP_REDIRECT_URI_SALESFORCE;
export const REACT_APP_REDIRECT_URI_HUBSPOT = window.env
  ? window.env.REACT_APP_REDIRECT_URI_HUBSPOT
  : process.env.REACT_APP_REDIRECT_URI_HUBSPOT;
export const REACT_APP_PUSHER_TOKEN = window.env
  ? window.env.REACT_APP_PUSHER_TOKEN
  : process.env.REACT_APP_PUSHER_TOKEN;
export const REACT_APP_PUSHER_CLUSTER = window.env
  ? window.env.REACT_APP_PUSHER_CLUSTER
  : process.env.REACT_APP_PUSHER_CLUSTER;
export const REACT_APP_CLIENT_ID_SALESFORCE = window.env
  ? window.env.REACT_APP_CLIENT_ID_SALESFORCE
  : process.env.REACT_APP_CLIENT_ID_SALESFORCE;
export const REACT_APP_CLIENT_ID_HUBSPOT = window.env
  ? window.env.REACT_APP_CLIENT_ID_HUBSPOT
  : process.env.REACT_APP_CLIENT_ID_HUBSPOT;
export const REACT_APP_MIXPANEL_TOKEN = window.env
  ? window.env.REACT_APP_MIXPANEL_TOKEN
  : process.env.REACT_APP_MIXPANEL_TOKEN;
export const NODE_ENV = process.env.NODE_ENV;
export const REACT_APP_SLACK_CLIENT_ID = window.env
  ? window.env.REACT_APP_SLACK_CLIENT_ID
  : process.env.REACT_APP_SLACK_CLIENT_ID;
export const REACT_APP_SLACK_OAUTH_URL = window.env
  ? window.env.REACT_APP_SLACK_OAUTH_URL
  : process.env.REACT_APP_SLACK_OAUTH_URL;
export const REACT_APP_ZENDESK_CLIENT_ID = window.env
  ? window.env.REACT_APP_ZENDESK_CLIENT_ID
  : process.env.REACT_APP_ZENDESK_CLIENT_ID;
export const REACT_APP_ZENDESK_OAUTH_URL = window.env
  ? window.env.REACT_APP_ZENDESK_OAUTH_URL
  : process.env.REACT_APP_ZENDESK_OAUTH_URL;
export const REACT_APP_TEAMS_CLIENT_ID = window.env
  ? window.env.REACT_APP_TEAMS_CLIENT_ID
  : process.env.REACT_APP_TEAMS_CLIENT_ID;
export const REACT_APP_TEAMS_OAUTH_URL = window.env
  ? window.env.REACT_APP_TEAMS_OAUTH_URL
  : process.env.REACT_APP_TEAMS_OAUTH_URL;
export const REACT_APP_REDIRECT_URI_TEAMS = window.env
  ? window.env.REACT_APP_REDIRECT_URI_TEAMS
  : process.env.REACT_APP_REDIRECT_URI_TEAMS;
export const REACT_APP_TEAMS_VALIDURLS = window.env
  ? window.env.REACT_APP_TEAMS_VALIDURLS
  : process.env.REACT_APP_TEAMS_VALIDURLS;
export const REACT_APP_ZENDESK_VALIDURLS = window.env
  ? window.env.REACT_APP_ZENDESK_VALIDURLS
  : process.env.REACT_APP_ZENDESK_VALIDURLS;
export const REACT_APP_SUPPORT_PROJECT_KEY = window.env
  ? window.env.REACT_APP_SUPPORT_PROJECT_KEY
  : process.env.REACT_APP_SUPPORT_PROJECT_KEY;
export const REACT_APP_SUPPORT_PROJECT_ID = window.env
  ? window.env.REACT_APP_SUPPORT_PROJECT_ID
  : process.env.REACT_APP_SUPPORT_PROJECT_ID;
export const REACT_APP_INTERNAL_ANALYTICS_NAV = window.env
  ? window.env.REACT_APP_INTEGRATIONS_ANALYTICS_NAV
  : process.env.REACT_APP_INTERNAL_ANALYTICS_NAV;
